export default {
  subheadline: 'Táto stránka umožňuje prispôsobiť používateľom definované významy podľa vlastných potrieb. Zmeny sa použijú pre všetkých používateľov',
};
